type Title = {
  title: string;
};
type Label = {
  label: string;
};

const itemIsTitle = (item: unknown): item is Title => {
  if (item && typeof item === 'object' && 'title' in item) {
    return typeof item.title === 'string';
  }

  return false;
};
const itemIsLabel = (item: unknown): item is Label => {
  if (item && typeof item === 'object' && 'label' in item) {
    return typeof item.label === 'string';
  }

  return false;
};
const itemToStringDefault = <T>(item: T | null) => {
  if (typeof item === 'string' || typeof item === 'number') {
    return item.toString();
  }

  if (itemIsTitle(item)) {
    return item.title;
  }

  if (itemIsLabel(item)) {
    return item.label;
  }

  return '';
};

const appendUniqueByKey = <T>(
  prevItems: T[],
  nextItems: T[],
  itemToKey: (item: T | null) => string | number
): {items: T[]; appendedCount: number} => {
  const seen = new Set(prevItems.map(item => itemToKey(item)));
  const unique = nextItems.filter(item => {
    const key = itemToKey(item);
    if (seen.has(key)) return false;

    seen.add(key);
    return true;
  });

  return {
    items: unique.length > 0 ? [...prevItems, ...unique] : prevItems,
    appendedCount: unique.length,
  };
};

export {appendUniqueByKey, itemToStringDefault};
